import { NeoModel } from "@singularsystems/neo-core";
import BaseStaticEventCommand from "./BaseStaticEventCommand";

@NeoModel
export default class CreateStaticEventCommand extends BaseStaticEventCommand {
    
}